module.exports = __webpack_public_path__ + "/img/5c0b9a306330e3de59d3962f2b82fdf1.png";